import angular from 'angular';
import DocFinderFileService from './doc-finder-file.service';
import StepFileService from './step-file.service';
import SpiceApiService from "../api/spice-api.service";

export default angular.module('FileModule', [])
    .factory('StepFileService', StepFileService)
    .factory('SpiceApiService', SpiceApiService)
    .service('DocFinderFileService', DocFinderFileService)

    .name; // must come last
